<template>
  <el-table-column
    prop="replacement_date"
    sortable="custom"
    label="Áthelyezés időpontja"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <div
        v-if="!scope.row.replacement_date"
      >
        Az áthelyezés még nem történt meg
      </div>
      <div v-else>
        {{ scope.row.replacement_date | dateTime }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'replacement_date',
  };
</script>
